module.exports = __webpack_public_path__ + "static/media/adellesans-bold-webfont.8059bb9c.ttf";